import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef } from "@angular/core";
import { AngularFireStorage, AngularFireUploadTask } from "angularfire2/storage";
import { Platform, ActionSheetController, LoadingController, AlertController } from "ionic-angular";
import { ImageProvider } from "../../providers/image/image";
import { Observable } from 'rxjs/Observable';
import * as mime from 'mime-types';
import { DatabaseProvider } from "../../providers/database/database";
import { PatientProvider } from "../../providers/patient/patient";
import { AuthProvider } from "../../providers/auth/auth";
import { Subject } from "rxjs";

@Component({
  selector: "document-upload",
  templateUrl: "document-upload.html",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentUploadComponent {
  private ngUnsubscribe: Subject<any> = new Subject();
  @Input() program_name: string;
  @Input() program_id: string;

  task: AngularFireUploadTask;

  progress: any; // Observable 0 to 100
  complete: any;
  ismobile: boolean;
  imageUrl: string; // base64
  pdfUrl: string;
  downloadUrl: string;
  image_type: string = 'prescription';
  user: any;

  snapshot: Observable<any>;
  isHovering: boolean;

  public mobileimages = [];

  constructor(
    public storage: AngularFireStorage,
    private image: ImageProvider,
    public loadingCtrl: LoadingController,
    public alertCtrl: AlertController,
    private cd: ChangeDetectorRef,
    private auth: AuthProvider,
    private dbPatient: PatientProvider,
    private db: DatabaseProvider
  ) {}

  ngOnInit() {
    this.auth.getCurrentUser().then(user => {
      this.user = { id: user.id, name: user.first_name + ' ' + user.last_name };
    });
  }

  ngOnDestroy() {
    console.log('Destroy doc upload component and subscriptions');
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  async createUploadTask(file: any) {
    return new Promise((resolve, reject) => {
     
      let filePath: any = null;
      filePath = `documents/${new Date().getTime()}_${file.name}.${file.ext}`;

      console.log("File Path: ", filePath);
      this.task = this.storage.ref(filePath).putString(file['b64'], "data_url")
    
      this.task.then((t) => {
        t.ref.getDownloadURL().then((u) => {
          file['url'] = u;
          file['type'] = 'NA'
          console.log("File Upload Complete: ", file); 
          this.db.addDocument(this.program_id, file, this.user);
          resolve();
        })
      });
      this.snapshot   = this.task.snapshotChanges();
      this.progress = this.task.percentageChanges();
    });
  }

  public uploadDesktopFiles(files: FileList) {
    console.log('Files: ', files);
    const loading = this.loadingCtrl.create({});
    loading.present();

    this.processFiles(Array.from(files)).then((uploads) => {
      setTimeout(() => {


        console.log('pre loop: ', uploads, uploads.length);
        const start = async () => {
          await this.asyncForEach(uploads, async (file) => {
            await this.createUploadTask(file);
          });
          console.log('done');
          loading.dismiss();
        }
        start();
      }, 500);
      });

      
  }

  async processFiles(files) {
    let i = [];
    await files.reduce(async (promise, file) => {
      // This line will wait for the last async function to finish.
      // The first iteration uses an already resolved Promise
      // so, it will immediately continue.
      await promise;
      this.image.getBase64(file).then((image) => {
        let filename = file.name;
        let name: any = file.name.split('.')[0].replace(' ','');
        let fileext: any = file.name.split('.')[1].replace(' ','');
        let mimetype: any = mime.lookup(fileext);
        i.push({ filename: filename, name: name, b64: image, ext: fileext, mimetype: mimetype });
      });
    }, Promise.resolve());
    return i;
  }

    // Determines if the upload task is active
    isActive(snapshot) {
      return snapshot.state === 'running' && snapshot.bytesTransferred < snapshot.totalBytes
    }

    toggleHover(event: boolean) {
      this.isHovering = event;
    }

  deleteImage(image)  {
    let index = this.mobileimages.indexOf(image);
    
        if (index > -1) {
          this.mobileimages.splice(index, 1);
        }
  }

  async asyncForEach(array, callback) {
    for (let index = 0; index < array.length; index++) {
      await callback(array[index], index, array)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/document-upload/document-upload.ts